import React from "react";
import { Link } from "react-router-dom";
import FeaturedHomeCard from "./FeaturedHomeCard";
import hshape from "../../assets/img/hshape.svg";

  const handleClick = (text) => {
    localStorage.setItem("categoryName", text);
  };
const FeaturedSection = () => {
    return (
        <section className="section-space pt-0">
            <div className="container-xl">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="main-h">
                            <h2 className="m-heading">Featured Online Care Courses</h2>
                            <img src={hshape} className='img-fluid ' alt="logo" />
                        </div>
                    </div>
                </div>
               
                       <FeaturedHomeCard />
                  
                <div className="text-center">
                  <Link to={`/courses`} className="btn btn-white mr-top" onClick={() => handleClick('courses')}>View All</Link>
                </div>
            </div>
        </section>
    );
};

export default FeaturedSection;